import { TOGGLE_MODAL } from 'app-redux/active/actions/types'

import { useActionless, useAppSelector } from 'app-redux/hooks'
import { useOwnsDeck } from 'hooks/usePermissions'

import Editor from 'components/formElements/richText/Editor'
import CommentContainer from 'components/deckPage/CommentContainer'
import PhatButton from 'components/formElements/PhatButton'

import styles from './deckHelpInfo.module.scss'

const DeckHelpInfo = () => {
  const [toggleModal] = useActionless(TOGGLE_MODAL)

  const deckHelp = useAppSelector(state => state.deck.deckHelp)

  const ownsDeck = useOwnsDeck()

  if (!deckHelp) return null

  const createdAt = deckHelp.createdAt ? new Date(deckHelp.createdAt) : new Date()

  createdAt.setDate(createdAt.getDate() + 7) // Add seven days

  return (
    <div className={styles.container}>
      {ownsDeck && (
        <div className={styles.header}>
          <div className={styles.left}>
            <h2>Deck help request is active</h2>
            <span>Expires: {createdAt.toLocaleDateString()}</span>
          </div>

          <PhatButton onClick={() => toggleModal({ modalName: 'deckHelp', flag: true })} icon="edit outline">
            Edit
          </PhatButton>
        </div>
      )}

      <Editor header="What is this deck trying to do?" readOnly value={deckHelp.goals} className={styles.commentBody} />
      <Editor
        header="What does this deck need help with?"
        readOnly
        value={deckHelp.issues}
        className={styles.commentBody}
      />

      <CommentContainer header="Have any suggestions?" />
    </div>
  )
}

export default DeckHelpInfo
